import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LayoutContext } from '../../contexts/layout';
import { pushFormFieldValidationResult, resetFormValidationResults } from '../../redux/actions/forms';
import { formTitlesSelector, formValidationRulesSelector, getFormValues } from '../../redux/selectors/forms';

export const useFormValidation = () => {
    const { layoutId } = useContext(LayoutContext);

    const formValues = useSelector(getFormValues(layoutId));
    const formTitles = useSelector(formTitlesSelector(layoutId));
    const validationRules = useSelector(formValidationRulesSelector(layoutId));

    const dispatch = useDispatch();

    const validateField = (fieldName: string) => {
        const formValue = formValues[fieldName];
        const rule = validationRules?.[fieldName];
        const title = formTitles?.[fieldName];

        if (rule instanceof Object && rule.required) {
            const isValueEmpty = typeof formValue === 'undefined' || formValue === null || formValue === '';
            const isSelectValue = Array.isArray(formValue) && formValue.length === 0;
            if (isValueEmpty || isSelectValue) {
                dispatch(pushFormFieldValidationResult(layoutId, fieldName, {
                    isValid: false,
                    message: `Поле "${title}" является обязательным`,
                }));
            }
        }
    };

    const validate = () => {
        if (validationRules instanceof Object) {
            dispatch(resetFormValidationResults(layoutId));

            try {
                const keys = Object.keys(validationRules);

                if (Array.isArray(keys) && keys.length > 0) {
                    keys.forEach(validateField);
                }
            } catch (err) {
                console.error('useFormValidation:', err);
            }
        }
    };

    return {
        validate,
    };
};
